import React from 'react';
import { Modal } from '../../ui/Modal';

interface ReportIssueModalProps {
  open?: boolean;
  reportIssueText: string;
  onTextChange: (e: React.ChangeEvent<HTMLTextAreaElement>) => void;
  onSubmit: () => void;
  onCancel: () => void;
}

export const ReportIssueModal: React.FC<ReportIssueModalProps> = ({ open = true, reportIssueText, onTextChange, onSubmit, onCancel }) => (
  <Modal open={open} onClose={onCancel}>
    <div className="text-center space-y-6">
      <h3 className="text-xl font-bold text-foreground mb-2">Report a Problem</h3>
      <p className="text-muted-foreground">
        Describe the issue you are experiencing. We will save this feedback.
      </p>
      <textarea
        value={reportIssueText}
        onChange={onTextChange}
        className="w-full bg-background border border-border rounded-lg p-4 text-foreground placeholder-muted-foreground focus:outline-none focus:border-ring resize-none h-32"
        placeholder="e.g., The AI is repeating itself..."
      />
      <div className="flex gap-3">
        <button
          onClick={onCancel}
          className="flex-1 bg-surface hover:bg-surface-hover text-foreground font-semibold py-3 px-6 rounded-lg transition-colors"
        >
          Cancel
        </button>
        <button
          onClick={onSubmit}
          className="flex-1 button-accent font-bold py-3 px-6 rounded-lg transition-colors"
          disabled={!reportIssueText.trim()}
        >
          Submit Report
        </button>
      </div>
    </div>
  </Modal>
);
